import { zodResolver } from '@hookform/resolvers/zod'
import { Percentage } from '@sparkdotfi/common-universal'
import { UseFormReturn, useForm } from 'react-hook-form'

import { ActionSettingsSchema, formatPercentageFormValue } from './form'
import { useStore } from '@/domain/state'

export const PREDEFINED_SLIPPAGES = [Percentage(0.0001), Percentage(0.0003), Percentage(0.001)] as const

export interface UseSlippageFormResult {
  form: UseFormReturn<ActionSettingsSchema>
  onSlippageChange: (value: string | Percentage, type: 'input' | 'button') => void
  reset: () => void
}

export function useSlippageForm(): UseSlippageFormResult {
  const initialSlippage = useStore((state) => state.actionsSettings.exchangeMaxSlippage)
  const initialSlippageType = PREDEFINED_SLIPPAGES.some((slippage) => slippage.eq(initialSlippage)) ? 'button' : 'input'

  const form = useForm<ActionSettingsSchema>({
    resolver: zodResolver(ActionSettingsSchema),
    defaultValues: {
      slippage: {
        value: formatPercentageFormValue(initialSlippage),
        type: initialSlippageType,
      },
    },
    mode: 'onChange',
  })

  function reset(): void {
    form.reset({
      slippage: {
        value: formatPercentageFormValue(initialSlippage),
        type: initialSlippageType,
      },
    })
  }
  function onSlippageChange(value: string | Percentage, type: 'input' | 'button'): void {
    const stringifiedValue = typeof value === 'string' ? value : formatPercentageFormValue(value)

    form.setValue(
      'slippage',
      {
        value: stringifiedValue,
        type,
      },
      { shouldValidate: true },
    )
  }

  return {
    form,
    onSlippageChange,
    reset,
  }
}
